(function() {
  function hasGiftProps(properties) {
    return Object.keys(properties || {}).some(
      (key) => /^Free Gift/i.test(key) || /^_FreeGiftVariantId/i.test(key)
    );
  }

  function getSanitizedProps(properties) {
    const sanitized = {};
    Object.keys(properties || {}).forEach((key) => {
      if (!/^Free Gift/i.test(key) && !/^_FreeGiftVariantId/i.test(key)) {
        sanitized[key] = properties[key];
      }
    });
    return sanitized;
  }

  function refreshCartUi() {
    if (window.location.pathname.includes('/cart')) {
      window.location.reload();
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );
  }

  function checkAndSanitizeCart() {
    if (window.freegoSettings?.showGiftItem) return;

    fetch('/cart.js')
      .then(res => res.json())
      .then(async (cart) => {
        if (!cart.items.length) return;

        const itemsToSanitize = cart.items.filter((item) =>
          hasGiftProps(item.properties || {})
        );

        if (!itemsToSanitize.length) return;

        const ops = itemsToSanitize.map((item) => ({
          item,
          sanitizedProps: getSanitizedProps(item.properties || {})
        }));

        if (!ops.length) return;

        for (const op of ops) {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({
              items: [{
                id: op.item.variant_id,
                quantity: op.item.quantity,
                properties: Object.keys(op.sanitizedProps).length ? op.sanitizedProps : undefined,
                selling_plan: op.item.selling_plan_id || undefined
              }]
            })
          });

          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ id: op.item.key, quantity: 0 })
          });
        }

        refreshCartUi();
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndSanitizeCart);
  } else {
    checkAndSanitizeCart();
  }
})();
